import { WhichClassTypeScreen } from '@/screens/name-screen/WhichClassTypeScreen'

export default function () {
  return <WhichClassTypeScreen />
}
